import { createContext, useMemo, useState } from "react";
import { deleteSession } from "./utils/session";

export const AuthContext = createContext();

function Provider({ children }) {
  const [isAuth, setIsAuth] = useState(null);
  const [userData, setUserData] = useState(null); // Added userData state
  const [isCreateProject, setIsCreateProject] = useState(false); // Added isCreateProject state

  const value = useMemo(
    () => ({
      isAuth,
      userData,
      isCreateProject,
      setIsAuth,
      setUserData,
      setIsCreateProject,
      activateAuth: () => setIsAuth(true),
      removeAuth: () => {
        setIsAuth(false);
        setUserData(null);
        setIsCreateProject(false);
        deleteSession();
      },
    }),
    [isAuth, userData, isCreateProject],
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

// eslint-disable-next-line import/no-anonymous-default-export
export default { Provider, Consumer: AuthContext.Consumer };
